<div *ngIf="isError" class="ot-form-error-container">
        <img src="assets/images/form_validation_error16.svg" class='ot-form-error-icon'>
        <label class="ot-form-error-message" *ngIf="controlDir?.errors?.maxlength" [for]="elementId">Too many
                characters</label>
        <label class="ot-form-error-message" *ngIf="controlDir?.errors?.minimum" [for]="elementId">Value too
                small</label>
        <label class="ot-form-error-message" *ngIf="controlDir?.errors?.maximum" [for]="elementId">Value too
                large</label>
        <label class="ot-form-error-message" *ngIf="controlDir?.errors?.required" [for]="elementId">Field is
                required</label>
        <label class="ot-form-error-message" *ngIf="controlDir?.errors?.pattern" [for]="elementId">Invalid
                characters</label>
</div>